import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variante = "primario" | "secundario" | "peligro" | "fantasma";
type Tamano = "sm" | "md";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: Variante;
  tamano?: Tamano;
  cargando?: boolean;
  children: ReactNode;
}

const CLASES_VARIANTE: Record<Variante, string> = {
  primario: "bg-principal text-superficie hover:bg-principal/90 disabled:bg-borde",
  secundario: "bg-superficie text-texto border border-borde hover:bg-fondo disabled:text-texto-secundario",
  peligro: "bg-error text-superficie hover:bg-error/90 disabled:bg-error/40",
  fantasma: "bg-transparent text-texto-secundario hover:bg-fondo disabled:text-borde",
};

const CLASES_TAMANO: Record<Tamano, string> = {
  sm: "px-2.5 py-1.5 text-sm",
  md: "px-3.5 py-2 text-sm",
};

const FOCO = "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2";

export function Boton({
  variante = "primario",
  tamano = "md",
  cargando = false,
  disabled,
  children,
  className = "",
  ...resto
}: Props) {
  return (
    <button
      disabled={disabled || cargando}
      className={`inline-flex items-center justify-center gap-1.5 rounded-lg font-medium transition-colors disabled:cursor-not-allowed ${FOCO} ${CLASES_VARIANTE[variante]} ${CLASES_TAMANO[tamano]} ${className}`}
      {...resto}
    >
      {cargando && <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent" />}
      {children}
    </button>
  );
}
